import React, { useEffect } from 'react';
import { BrowserRouter }    from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { I18nextProvider } from 'react-i18next';
import { store } from './Redux/Bootstrap';
import { theme } from './Config/theme';
import { GlobalStyles } from './Config/GlobalStyles';
import i18n from './Config/i18n';
import Router from './View/Application/Router';
import { CartProvider } from './Context/CartContext';
import { CountryProvider } from './Context/CountryContext';
import FloatingBadges from 'View/Component/FloatingBadges/FloatingBadges';
import CookieBanner from 'View/Component/CookieBanner/CookieBanner';
import { handleAnalyticsConsent, initializeGoogleAnalytics } from 'Utils/googleAnalytics';
import { CookieConsent, loadConsent }                        from 'Utils/cookieConsent';


const App: React.FC = () => {

  useEffect(() => {
    const existingConsent = loadConsent();

    if (existingConsent?.statistics) {
      initializeGoogleAnalytics();
    }

    const onConsentChange = (event: Event) => {
      const customEvent = event as CustomEvent<CookieConsent | null>;
      handleAnalyticsConsent(customEvent.detail);
    };

    window.addEventListener('mrlw:cookieConsent', onConsentChange);

    return () => {
      window.removeEventListener('mrlw:cookieConsent', onConsentChange);
    };
  }, []);

  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider theme={theme}>
          <CountryProvider>
          <CartProvider>
            <GlobalStyles />
            <BrowserRouter>
              <Router />
              <FloatingBadges
                whatsAppPhone="4915771334302"
                whatsAppMessage="Hallo, ich habe eine Frage zu einer Uhr."
              />
              <CookieBanner />
            </BrowserRouter>
          </CartProvider>
          </CountryProvider>
        </ThemeProvider>
      </I18nextProvider>
    </Provider>
  );
};

export default App;
